module.exports = __webpack_public_path__ + "static/media/spring-pat2.13d06e64.jpg";